import { generateRowsData } from "./generateBuildingRowsData";
import { columns } from "./buildingColumns";

export const generateBuildingTableData = (rawData) => {
    var rowsData = generateRowsData(rawData)
    return {rows: rowsData, columns: columns }
}